<form id="payment-form">
  <div id="payment-element">
    <!-- Elements will create form elements here -->
  </div>
  <button id="submit" type="submit" [disabled]="stripeSubmitDisable" [ngClass]="{'hide': !elementReady}">PAY</button>
  <div id="error-message">
    <!-- Display error message to your customers here -->
  </div>
</form>
